import { Store } from '@reduxjs/toolkit';
import { Persistor } from 'redux-persist';

import cognitoIdentityProvider from '../cognito';

// True when this page is rendered inside the operations-ui vendor impersonation iframe
export const isEmbeddedInOperationsUI = (): boolean => {
  if (window.self === window.top || !CONFIG.ui.operationsUIURL) {
    return false;
  }

  // Firefox doesn't implement ancestorOrigins, so it relies on the referrer
  const parentOrigin = window.location.ancestorOrigins?.[0] ?? (document.referrer ? new URL(document.referrer).origin : undefined);

  return parentOrigin === CONFIG.ui.operationsUIURL;
};

function waitForRehydration(persistor: Persistor): Promise<void> {
  return new Promise((resolve) => {
    if (persistor.getState().bootstrapped) {
      resolve();
      return;
    }

    const unsubscribe = persistor.subscribe(() => {
      if (persistor.getState().bootstrapped) {
        unsubscribe();
        resolve();
      }
    });
  });
}

// Impersonation changes custom:vendorId server-side, so persisted state may belong to the previous vendor. Resetting
// all but auth keeps the operator logged in and writes clean state to persist:root, which standalone tabs also read.
export async function prepareOperationsImpersonation(store: Store, persistor: Persistor): Promise<void> {
  await cognitoIdentityProvider.refreshCurrentSession().catch((error) => {
    console.error('Failed to refresh session for operations-ui impersonation:', error);
  });
  await waitForRehydration(persistor);
  store.dispatch({ type: 'RESET_VENDOR_STATE' });
}
